export const veSpecificFields = {
    maintenanceBookPresented: null,
    work1_maintenanceProblem: null,
    work1_commentMaintenanceProblem: null,
    work2_maintenanceProblem: null,
    work2_commentMaintenanceProblem: null,
    work3_maintenanceProblem: null,
    work3_commentMaintenanceProblem: null,
    work4_maintenanceProblem: null,
    work4_commentMaintenanceProblem: null,
    work5_maintenanceProblem: null,
    work5_commentMaintenanceProblem: null,
};
